import { render, staticRenderFns } from "./addNewOwnerDialog.vue?vue&type=template&id=fc4b9e48&scoped=true&"
import script from "./addNewOwnerDialog.vue?vue&type=script&lang=js&"
export * from "./addNewOwnerDialog.vue?vue&type=script&lang=js&"
import style0 from "./addNewOwnerDialog.vue?vue&type=style&index=0&id=fc4b9e48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b9e48",
  null
  
)

export default component.exports